interface SidebarsProps {
  children: React.ReactNode;
}

const Sidebars = ({ children }: SidebarsProps) => {
  return <> {children}</>;
};

export default Sidebars;
